import { render, staticRenderFns } from "./HouseDescDialog.vue?vue&type=template&id=3882e364&scoped=true&lang=pug&"
import script from "./HouseDescDialog.vue?vue&type=script&lang=ts&"
export * from "./HouseDescDialog.vue?vue&type=script&lang=ts&"
import style0 from "./HouseDescDialog.vue?vue&type=style&index=0&id=3882e364&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3882e364",
  null
  
)

export default component.exports